import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {finalize} from 'rxjs/operators';
import {SharedFacadeService} from './shared-facade.service';

@Injectable({
  providedIn: 'root'
})
export class CountRequestInterceptorService implements HttpInterceptor {

  constructor(private _sharedFacadeService: SharedFacadeService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.incrementCountRequest();
    return next.handle(req).pipe(
      finalize(() => this.decrementCountRequest())
    );
  }

  private incrementCountRequest() {
    this._sharedFacadeService.incrementCountRequest();
  }

  private decrementCountRequest() {
    this._sharedFacadeService.decrementCountRequest();
  }
}
